export const usePersistanceKey = () => {
  const { pathname } = window.location;
  const persistanceKey = pathname.substring(1).split('/').join('§');
  return persistanceKey;
};
